/* © 2024 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
export var CustomRow = function CustomRow(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketing-content EmbersTemplate-marketingCustom-root"
  }, children);
};